import { Box, Stack } from '@mui/material';
import React from 'react';

import { ContractDateRangeResponse } from '../IMessageBubbleInterface';

import { CardFollowUp, CardHeaderRow, CardIntro, CardShell, MetricTile } from './sharedCardHelpers';

export const ContractDateRangeCard: React.FC<{ contractDateRange: ContractDateRangeResponse | null }> = ({
    contractDateRange,
}) => {
    if (!contractDateRange) return null;

    return (
        <Box>
            <CardIntro text={contractDateRange.intro} />

            <Stack gap={0.9}>
                {contractDateRange.items.map((item, itemIdx) => (
                    <CardShell key={`${item.contractId}-${itemIdx}`}>
                        <CardHeaderRow contractId={item.contractId} />

                        <Box
                            sx={{
                                p: 0.9,
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                gap: 0.7,
                            }}
                        >
                            <MetricTile label="START DATE" value={item.startDate || '-'} />
                            <MetricTile label="END DATE (MATURITY)" value={item.endDate || '-'} />
                        </Box>
                    </CardShell>
                ))}
            </Stack>

            <CardFollowUp text={contractDateRange.followUp} />
        </Box>
    );
};
